export default __webpack_public_path__ + "media/images/icons/smile-wink-regular-cc407d0b760af209123444d61c264ff3.svg";